var _rect, _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 169,
    height: 66,
    viewBox: "0 0 169 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 169,
    height: 66,
    rx: 33,
    fill: "#5F4AE5"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 135,
    cy: 33,
    r: 30,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M53.428 23.234L45.812 37.752V47H43.432V37.752L35.748 23.234H38.434L44.622 35.576L50.776 23.234H53.428ZM59.2914 25.172V34.046H68.3014V36.018H59.2914V45.028H69.3214V47H56.9114V23.2H69.3214V25.172H59.2914ZM81.219 47.238C79.655 47.238 78.2723 46.966 77.071 46.422C75.8923 45.878 74.963 45.1187 74.283 44.144C73.603 43.1693 73.2403 42.0813 73.195 40.88H75.711C75.8243 42.036 76.3343 43.056 77.241 43.94C78.1477 44.8013 79.4737 45.232 81.219 45.232C82.8283 45.232 84.0977 44.824 85.027 44.008C85.979 43.1693 86.455 42.1153 86.455 40.846C86.455 39.826 86.1943 39.01 85.673 38.398C85.1517 37.7633 84.5057 37.2987 83.735 37.004C82.9643 36.6867 81.899 36.3467 80.539 35.984C78.9523 35.5533 77.6943 35.134 76.765 34.726C75.8357 34.318 75.0423 33.6833 74.385 32.822C73.7277 31.9607 73.399 30.7933 73.399 29.32C73.399 28.096 73.7163 27.008 74.351 26.056C74.9857 25.0813 75.881 24.322 77.037 23.778C78.193 23.234 79.519 22.962 81.015 22.962C83.2137 22.962 84.9817 23.506 86.319 24.594C87.679 25.6593 88.461 27.042 88.665 28.742H86.081C85.9224 27.7673 85.3897 26.906 84.483 26.158C83.5763 25.3873 82.3523 25.002 80.811 25.002C79.383 25.002 78.193 25.3873 77.241 26.158C76.289 26.906 75.813 27.9373 75.813 29.252C75.813 30.2493 76.0737 31.054 76.595 31.666C77.1163 32.278 77.7623 32.7427 78.533 33.06C79.3263 33.3773 80.3917 33.7173 81.729 34.08C83.2703 34.5107 84.517 34.9413 85.469 35.372C86.421 35.78 87.2257 36.4147 87.883 37.276C88.5403 38.1373 88.869 39.2933 88.869 40.744C88.869 41.8547 88.5743 42.9087 87.985 43.906C87.3957 44.9033 86.523 45.708 85.367 46.32C84.211 46.932 82.8283 47.238 81.219 47.238Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYes);
export default __webpack_public_path__ + "static/media/Yes.381d67790df3e4887bba65d97b5222a9.svg";
export { ForwardRef as ReactComponent };